import { useMutation, useQueryClient } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../CommonUtils/httpBodyOptions';
import { queryKeys } from './queryKeys';

interface Params {
  clientId: string;
  url: string;
}

const addGoal = ({ url, clientId }: Params) => {
  return authFetch(url, {
    method: 'POST',
    ...httpBodyOptions({ clientId }),
  });
};

interface MutationParams {
  clientId: string;
}

export const useAddGoalMutation = ({ clientId }: MutationParams) => {
  const queryClient = useQueryClient();

  return useMutation(addGoal, {
    async onSuccess() {
      await queryClient.invalidateQueries(queryKeys.goals(clientId));
    },
  });
};
